import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ScreenService } from '../../services/screen.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.css']
})
export class PopupComponent implements OnInit, OnDestroy {
  private currentUser: any;
  private currentXmls: Array<any> = [];
  public currentSchduleFiles: Array<any> = [];
  private scheduleFilesData: Array<any> = [];
  public availableList: Array<any> = [];
  private selectedList: Array<any> = [];
  public schedulerName: String = '';
  private gContentDirectory = '../Content/';
  private gActiveResolution = '1280x720';
  public scheduled_screen_attributes = [];
  public popupScreenAttributes = [];
  isSavingFile: boolean;
  isPublishing: boolean;
  isScreenSaved: boolean;
  public selectedScheduleFile;
  private modalRef;
  private defaultSchedule = null;
  public currentUserServers: Array<any> = [];
  public selectedChannel = 0;
  // private selectedPublishChannel = { iD: 0, endpointLocationName: '-- Groups --' };
  public selectedPublishChannel = '0';
  private scheduleFiles = [];
  private imageFiles = [];
  private videoFiles = [];
  private otherFiles = [];
  private error = false;

  public availableChannels = [
    '89'
  ];

  @ViewChild('schedulerCalendarModal') private schedulerCalendarModal;

  constructor(
    private authService: AuthService,
    private screenService: ScreenService,
    private modalService: NgbModal
  ) {
    this.currentUser = this.authService.currentUser;
  }

  ngOnInit() {
    const currYear = new Date().getFullYear();

    this.availableList = [];
    this.currentSchduleFiles = [];
    this.currentXmls = [];

    this.screenService.getCurrentUserFiles().subscribe((response) => {
      this.currentXmls = response.data.xmls;
      this.currentSchduleFiles = response.data.scheduleFiles;
      this.readScreenlistFileDetails();
      this.readScheduleFileDetails();
      this.selectedScheduleFile = 0;
    });

    this.getCurrentUserServers();
    // this.initializePopUpScreenAsset();
  }

  initialize() {
    this.currentSchduleFiles = [];
    this.currentXmls = [];
    this.screenService.getCurrentUserFiles().subscribe((response) => {
      this.currentXmls = response.data.xmls;
      this.currentSchduleFiles = response.data.scheduleFiles;
      // this.readScreenlistFileDetails();
      this.readScheduleFileDetails();
      this.selectedScheduleFile = 0;
    });
  }

  allowDrop(ev) {
    ev.preventDefault();
  }

  drag(ev) {
    ev.dataTransfer.setData('drag_id', ev.target.id);
  }

  drop(ev) {
    ev.preventDefault();
    if (this.scheduled_screen_attributes.length === 2) {
      this.authService.showNotification('Only two screens can be selected', 'error');
      return;
    }
    let data = ev.dataTransfer.getData('drag_id');
    data = data.split('_');
    const listName = data[0];
    const id = data[1];
    // const dropZone = ev.target.attributes['id'].value.split('_')[0];
    if (listName === 'avail') {
      this.selectedList.push(this.availableList[id]);
      this.generateScreensSchedule(this.availableList[id]);
    }
  }

  readScreenlistFileDetails() {
    let userName = '';
    if (typeof this.authService.currentUser.username !== 'undefined') {
      userName = this.authService.currentUser.username;
    }
    const reqData = {
      userName: userName,
      fileName: null,
      templatesRelativePath: null
    };

    this.currentXmls.forEach((item) => {
      reqData.fileName = item.name;
      this.screenService.readScreenlistFile(reqData).subscribe((response) => {
        response.data.screenlist.channelNumber = this.getChannelNumber(item.name);
        this.availableList.push(response.data.screenlist);
      }, (error) => {
        console.log(error);
      });
    });
  }

  getCurrentUserServers() {
    this.screenService.getUserServerList(this.authService.currentUser.userID).subscribe((response) => {
      // this.currentUserServers.push(this.selectedPublishChannel);
      response.data.forEach(element => {
        this.currentUserServers.push(element.endpointLocationName);
      });
      // this.currentUserServers = this.currentUserServers.concat(response.data);
    }, (error) => {
      console.log(error);
    });
  }

  readScheduleFileDetails() {
    let userName = '';
    if (typeof this.authService.currentUser.username !== 'undefined') {
      userName = this.authService.currentUser.username;
    }
    const reqData = {
      userName: userName,
      fileName: null,
      templatesRelativePath: null
    };

    this.currentSchduleFiles.forEach((item) => {
      const id = this.generateRandomId();
      reqData.fileName = item.name;
      this.screenService.readScheduleFile(reqData).subscribe((response) => {
        this.scheduleFilesData.push({
          id: id,
          channelNum: item.name.substr(15, 2),
          name: response.data.scheduleScreenList.name,
          data: response.data.scheduleScreenList.scheduleScreens
        });
        item.channelNum = item.name.substr(15, 2);
        item.name = response.data.scheduleScreenList.name;
        item.id = id;
      }, (error) => {
        console.log(error);
      });
    });
  }

  createScreenList(): object {
    // set the global variable name to the just provided screenlist name

    // *****************************************************
    // ** Get each of the required values to be entered into the file **
    // *****************************************************
    const dmb_attributes = {
      'version': '1.0',
      'timestamp': this.currentTimeStamp()
    };

    const screenlist_attributes = {
      'filename': 'dmb.screenlist.89.xml',
      'name': 'Default-Screen',
      'resolution': this.gActiveResolution,
      'content_directory': this.gContentDirectory
    };

    this.initializePopUpScreenAsset();

    this.scheduled_screen_attributes.forEach((screen) => {
      if (screen.default === true) {
        this.popupScreenAttributes[0].ScreenAssets = screen.screen.asset.concat(this.popupScreenAttributes[0].ScreenAssets);
        this.popupScreenAttributes[0].ScreenAttributes.background_color = screen.screen.background_color;
        this.popupScreenAttributes[0].ScreenAttributes.name = screenlist_attributes.name = this.popupScreenAttributes[0].name = screen.name;
      } else {
        this.popupScreenAttributes[1].ScreenAssets = screen.screen.asset;
        this.popupScreenAttributes[1].ScreenAttributes.background_color = screen.screen.background_color;
      }
    });

    return {
      UserName: this.currentUser.userName,
      userID: this.currentUser.userID,
      DmbAttributes: dmb_attributes,
      ScreenlistAttributes: screenlist_attributes,
      ScheduledScreensObjects: this.popupScreenAttributes
    };
  }

  initializePopUpScreenAsset() {
    this.popupScreenAttributes = [];
    const screenElement = {
      'name' : 'Default-Screen',
      'screen' : {
        'on_boot_only' : 'no',
        'active' : 'yes',
        'background_color' : '255.0.0.0',
        'exit_on_video_end' : 'no',
        'asset' : {
          'name': 'Overlay',
          'type': 'overlay',
          'x': '5',
          'y': '5',
          'width': '5',
          'height': '5',
          'source': '228.5.6.7:1234',
          'onalert': {
            'screen': 'Pop-up Screen'
          }
        }
      }
    };

    this.generateScreensScheduleInit(screenElement);

    const secondScreenElement = {
      'name' : 'Pop-up Screen',
      'screen' : {
        'on_boot_only' : 'no',
        'active' : 'no',
        'background_color' : '255.0.0.0',
        'exit_on_video_end' : 'no',
        'asset' : {
          'name': 'Pop-Up',
          'type': 'text',
          'local_edit': 'no',
          'x': '5',
          'y': '5',
          'width': '5',
          'height': '5',
          'source': 'Hello me!'
        }
      }
    };

    this.generateScreensScheduleInit(secondScreenElement);
  }

  generateScreensScheduleInit(screenElement) {
    const scheduleScreenObj = {
      'ScreenAttributes': null,
      'ScreenAssets': null,
      'name': screenElement.name,
      'id': this.generateRandomId()
    };

    scheduleScreenObj.ScreenAttributes = {
      'name': screenElement.name,
      'on_boot_only': screenElement.screen.on_boot_only,
      'active': screenElement.screen.active,
      'background_color': screenElement.screen.background_color,
      'exit_on_video_end': screenElement.screen.exit_on_video_end
    };

    scheduleScreenObj.ScreenAssets = [screenElement.screen.asset];
    this.popupScreenAttributes.push(scheduleScreenObj);
  }

  generateScreensSchedule(screenElement, existingSelected = false) {
    const scheduleScreenObj = {
      'ScreenAssets': null,
      'name': screenElement.name,
      'id': this.generateRandomId()
    };

    scheduleScreenObj.ScreenAssets = screenElement.screen.asset;
    this.scheduled_screen_attributes.push(screenElement);
  }

  /**
   *  Once the user has entered the screenlist file name, create or update the xml file in the 'Contnet' directory
   */
  createPopupXML(): void {
    if (this.scheduled_screen_attributes.length < 2) {
      this.authService.showNotification('Please select atleast two screen', 'error');
      return;
    }

    let hasDefaultScreen = false;

    this.scheduled_screen_attributes.forEach((screen) => {
      if (screen.default === true) {
        hasDefaultScreen = true;
      }
    });

    if (!hasDefaultScreen) {
      this.authService.showNotification('Please select a default screen', 'error');
      return;
    }

    const data = this.createScreenList();
    this.isSavingFile = true;
    this.screenService.savePopupXmlFile(data).subscribe((response) => {
      this.authService.showNotification('Screen saved successfully', 'success', 'success');
      this.isSavingFile = false;
      this.isScreenSaved = true;
      this.isSavingFile = false;
      this.initialize();
    }, error => {
      this.authService.showNotification('Some error occured please try again later', 'error');
      this.isSavingFile = false;
    });
  }

  currentTimeStamp(): string {
    const date = new Date();
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();
    const minutes = date.getMinutes();
    const hours = date.getHours();
    const seconds = date.getSeconds();
    const myFormattedDate = day + '-' + (monthIndex + 1) + '-' + year + ' ' + hours + ':' + minutes + ':' + seconds;
    return myFormattedDate;
  }

  scheduleChanged($event) {
    this.scheduleFiles = [];
    this.otherFiles = [];
    this.videoFiles = [];
    this.imageFiles = [];
    this.scheduleFilesData.forEach((item) => {
      if (item.id === $event) {
        item.data.forEach(element => {
          element.screen = element;
          this.generateScreensSchedule(element, true);
        });
        this.selectedChannel = item.channelNum;
        this.schedulerName = item.name;
        return;
      }
    });
  }

  prepareAssetList(screenAsset) {
    screenAsset.forEach(element => {
      if (element.playlist && element.playlist_items.length > 0) {
        this.otherFiles.push(element.playlists.file_name);
        element.playlist_items.forEach(plItem => {
          if (plItem.type === 'image') {
            this.imageFiles.push(plItem.name);
          } else if (plItem.type === 'video') {
            this.videoFiles.push(plItem.name);
          }
        });
      }else if (element.type === 'image') {
        this.imageFiles.push(element.source);
      } else if (element.type === 'video') {
        this.videoFiles.push(element.source);
      }
    });
  }

  setDefaultScreen(index) {
    if (this.defaultSchedule === index) {
      this.defaultSchedule = null;
    } else {
      this.defaultSchedule = index;
    }
    this.scheduled_screen_attributes[index].default = true;
  }

  removeScreen(index) {
    if (this.defaultSchedule === index) {
      this.defaultSchedule = null;
    }
    this.scheduled_screen_attributes.splice(index, 1);
  }

  generateRandomId() {
    return '_' + Math.random().toString(36).substr(2, 9);
  }

  openModel(content, config?: object, type?: string) {
    if (typeof config === 'undefined') {
      config = {};
    }
    this.modalRef = this.modalService.open(content, config);

    this.modalRef.result.then((result) => {
      console.log('`Closed with: ${result}`');
    }, (reason) => {
      console.log('`Dismissed ${this.getDismissReason(reason)}`');
    });
  }

  publish() {
    let userName = '';
    if (typeof this.authService.currentUser.username !== 'undefined') {
      userName = this.authService.currentUser.username;
    }

    if (this.selectedPublishChannel === '0' || !this.authService.currentUser) {
      return;
    }
    const filesToUpload = {
      images: [],
      videos: [],
      xmls: ['dmb.screenlist.89.xml'],
      isPopupScreen: true,
      userName: userName,
      serverName: 'content server',
      others: [],
      schedules: [],
      EndpointLocationName: this.selectedPublishChannel.toLowerCase(),
      endpointLocationName: this.selectedPublishChannel.toLowerCase(),
    };
    this.isPublishing = true;
    this.screenService.previewScreenlistFile(filesToUpload).subscribe((response) => {
      if (response.status === 'error') {
        // this.authService.showNotification('', response.message, 'error');
        this.authService.showNotification('', 'Error: Publish failed', 'error');
      } else {
        // this.authService.showNotification(response.message, 'success');
        this.authService.showNotification('Publish Successful', 'success', 'success');
      }
      this.isPublishing = false;
    }, error => {
      this.isPublishing = false;
      this.authService.showNotification('Some error occured please try again later', 'error');
    });


  }

  getChannelNumber(fileName: String) {
    const fileContents = fileName.split('.');
    const channelNumber = parseInt(fileContents[fileContents.length - 2], 10);
    if (channelNumber === 0) {
      return 'Default';
    }
    return 'Ch. ' + channelNumber;
  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// ./src/app/components/popup/popup.component.ts